
import { createContext, useReducer } from "react";
import BagageReducer from "./BagageReducer";

const INITIAL_STATE = {
    bagages: [],
    count: 1,
    isFetching: true,
    error: false,
};


export const BagageContext = createContext(INITIAL_STATE);

export const BagageContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(BagageReducer, INITIAL_STATE);
    
    return (
      <BagageContext.Provider
        value={{
          bagages: state.bagages,
          count: state.count,
          isFetching: state.isFetching,
          error: state.error,
          dispatch,
        }}
      >
        {children}
      </BagageContext.Provider>
    );
  };